import React, { useState, useEffect } from "react";

//icons
import medium from "../../assets/icons/whats.svg";

const WhatsappComponent = () => {
  const redirectWapp = () => {
    window.open("https://api.whatsapp.com/send?phone=573152003046");
    //window.location.href = "https://api.whatsapp.com/send?phone=+573152003046&text=Hola!%20Buen%20Dia"
  };

  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <div className="floating">
        <div className="whatsapp" style={{ cursor: "pointer" }}>
          <img onClick={() => redirectWapp()} src={medium}></img>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WhatsappComponent;
